var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height"
    },
    [
      _c("gg-card-header", [_vm._v(" Select Period ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _vm._v(" Select a period for the report view. "),
                  _c(
                    "v-row",
                    {
                      staticClass: "pt-3"
                    },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "11",
                            sm: "5"
                          }
                        },
                        [
                          _vm.period === "monthly"
                            ? _c(
                                "v-menu",
                                {
                                  ref: "menu",
                                  attrs: {
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "max-width": "290px",
                                    "min-width": "auto"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function fn(_ref) {
                                          var on = _ref.on,
                                            attrs = _ref.attrs
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _c("gg-input-label", [
                                                  _vm._v("Reporting Period")
                                                ]),
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          dense: "",
                                                          outlined: "",
                                                          autocomplete: "off",
                                                          value:
                                                            _vm.formattedDate,
                                                          "prepend-icon":
                                                            "mdi-calendar",
                                                          readonly: ""
                                                        }
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2516778958
                                  ),
                                  model: {
                                    value: _vm.menu,
                                    callback: function callback($$v) {
                                      _vm.menu = $$v
                                    },
                                    expression: "menu"
                                  }
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      type: "month",
                                      min: "2009-01-01",
                                      "no-title": "",
                                      scrollable: "",
                                      max: _vm.currentDate
                                    },
                                    model: {
                                      value: _vm.date,
                                      callback: function callback($$v) {
                                        _vm.date = $$v
                                      },
                                      expression: "date"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("gg-select", {
                                attrs: {
                                  label: "Reporting Period",
                                  items: _vm.years
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function callback($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }